module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAMZJREFUKBWNjj8OAUEUh5fVKTmARKNFpRctLRXVKl2AE6gdwAm2EYlrkKBZjStIFJLxjbzJ7OxMsl7y7fuz3y+ZKKKUUi3YQFfvpYXYgAx0nSH+J5T8dPtZloWqCIOCNC/s3qpDWe56Z57m9vDIqzr2ZSoJW4EroaMEn/RmQPFPiH14S/BAr/hW4IK4kJBue6gbjXkMI7M7nR9bMHVl6MEEPnJM6W0npBeOq5wkrtNuXkiCQ7SHo9plFwxJsIY3gxO84AJriL/zDfcGSaT1HQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-phone.png
// module id = 1405
// module chunks = 0